import React from 'react';
import { Navigate, Route, Routes, useMatch, useNavigate, useParams } from 'react-router-dom';
import { access, defaultRoute } from '../../../common/Tool';
import { Affix, Layout, Menu, Divider, Tooltip } from 'antd';
import { QueryDetail, QueryOrder, QueryParam, useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';
import Icofont from 'react-icofont';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import Main from './Main';
import Events from './Events';
import Notify from './Notify';
import Infrastructure from './Infrastructure';
import CommonEventsAdmin from '../CommonEventsAdmin';
import CommonEventsAdminByID from '../CommonEventsAdminByID';
import { BreadcrumbsProvider, MenuLevelTwoContext, MenuLevelTwoElementContext } from '../../../common/Context';
import ContextRoute, { ContextList } from '../ContextRoute';
import { ContextEventSellingElement } from '../../components/ContextElement';
import Selling from './Selling';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

function MenuLevelTwo({ menu }) {
    let navigate = useNavigate();
    let match = useMatch({
        // path: "/app/:one",
        path: "/app/:one/:two",
        // path: "/app/:one/:two/:three",
        caseSensitive: false,
        end: false
    })
    const role_by_id = useSelector(state => state.home.role_by_id);

    if (menu.length <= 0) return (<></>);
    const style = {
        marginBottom: "0px",
        marginTop: "0px",
        fontSize: "13px",
        paddingRight: "10px"
    }
    const l = (element, key) => {
        const icon = (element.icon) ? element.icon(element) : <></>;
        return (
            <Menu.Item style={style} key={key}>
                <Tooltip title={element.name} mouseEnterDelay={0.8}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {icon}{element.name}
                        </div>
                    </div>
                </Tooltip>
            </Menu.Item>
        )
    }
    const elements = menu.map((element, index) => {
        const key = element.uuid || element.key || index;
        if (element.group) {
            const ui = element.group.map(e => {
                return l(e, e.uuid)
            })
            return (
                <Menu.SubMenu
                    key={element.uuid}
                    title={<span style={style}>{element.title}</span>}
                    inlineIndent={0}
                >
                    {ui}
                </Menu.SubMenu>
            )
        } else {
            return l(element, key)
        }
    })
    const change = ({ key }) => {
        navigate(key);
    }
    return (
        <>
            <Divider type="horizontal"
                orientation="left"
                style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
                Подменю
            </Divider>
            <Menu
                className={"menu-level-two"}
                mode="inline"
                defaultSelectedKeys={[match?.params?.two]}
                selectedKeys={[match?.params?.two]}
                style={{ border: "none" }}
                inlineIndent={10}
                onClick={change}
            >
                {elements}
            </Menu>
        </>
    )
}
export default function Common(props) {
    let { id } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const siteAccess = useSelector(state => state.siteAccess.value);

    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status, () => { }); // Статусы
    const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

    const menu = (status, notify) => {
        const x = [
            {
                uuid: "main",
                name: "Главная",
                icon: function () {
                    return (<span className="anticon"><Icofont icon="home" /></span>)
                },
                component: (props) => (<Main {...props}/>),
                role: [
                    { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                ]
            },
            {
                uuid: "events",
                default: true,
                name: "Мероприятия",
                icon: function () {
                    return (<span className="anticon"><Icofont icon="ui-calendar" /></span>)
                },
                component: (props) => (<Events {...props}/>),
                role: [
                    { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                    // { "ID": 30, "nazvanie": "АдминистраторМероприятия" },
                ]
            },
            {
                uuid: "notify",
                default: false,
                name: "Уведомления",
                icon: function () {
                    return (<span className="anticon"><Icofont icon="notification" /></span>)
                },
                component: (props) => (<Notify {...props}/>),
                role: [
                    { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                ],
            },
            {
                uuid: "infrastructure",
                name: "Инфраструктура",
                icon: function () {
                    return (<span className="anticon"><Icofont icon="instrument" /></span>)
                },
                component: (props) => (<Infrastructure {...props}/>),
                role: [
                    { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                ]
            },
            {
				uuid: "selling",
				name: "Продажи",
				// unvisible: true,
				// color: "#FF7900", // #3B3C36
                icon: function () {
                    return (<i className="fa fa-credit-card"></i>)
                },
                
				component: (props) => (
					<ContextRoute uuid=":id"
						display={(item) => <ContextEventSellingElement item={item} color={"#FF7900"} />}
						displayString={(item) => item?.nazvanieMeropriyatiya
						}
                        queryDetail="collection"
						params={[
							QueryOrder("nachaloSorevnovaniya", "DESC"),
						]}
						listSource="/api/agentskie-voznagrazhdeniya/my-meropriyatiya"
						list={<ContextList
							{...props}
							title={<div style={{ padding: "10px 7px", fontSize: "16px" }}>Выберите мероприятие по которому хотите просмотреть результаты продаж</div>}
							empty={<div>Нет доступных мероприятий</div>}
						/>}

						itemSource="/api/agentskie-voznagrazhdeniya/my-meropriyatiya"
						item={<Selling {...props} />}
						
					/>),
				role: [
					// { "ID": 4, "nazvanie": "ОбычныйПользователь" },
                    { "ID": 35, "nazvanie": "Артист" },
                    { "ID": 34, "nazvanie": "Промоутер" },
                    { "ID": 33, "nazvanie": "Куратор" },
                    { "ID": 18, "nazvanie": "ВладелецШколыФедерации" },
				]
			},
            // {
            //     uuid: "admin",
            //     name: "Администрирование",
            //     icon: function () {
            //         return (<span className="anticon"><Icofont icon="gear" /></span>)
            //     },
            //     component: (props) => (<CommonEventsAdmin {...props} auth={auth} />),
            //     role: [
            //         { "ID": 30, "nazvanie": "АдминистраторМероприятия" },
            //     ]
            // },
            // {
            //     uuid: "admin/:id",
            //     hidden: true,
            //     name: "Мероприятие",
            //     component: (props) => (<CommonEventsAdminByID {...props} auth={auth} />),
            //     role: [
            //         { "ID": 30, "nazvanie": "АдминистраторМероприятия" },
            //     ]
            // },
        ]
        return x
    };

    return (
        <div>
            <MenuLevelTwoContext.Provider value={menu(status, notify)}>
                {(!siteAccess || siteAccess == "allow") && <Routes>
                    {defaultRoute(menu(status, notify), role_by_id)}
                    {menu(status, notify).map((e, idx) => {
                        if (e.component && access(e, role_by_id)) {
                            return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
                                <BreadcrumbsProvider value={{
                                    // parent: props?.level,
                                    uuid: e?.uuid,
                                    name: e?.name,
                                    color: e?.color,
                                    role: e?.role,
                                    hidden: e.hidden
                                }}>
                                    {e.component({})}
                                </BreadcrumbsProvider>}
                            />
                        }
                    })}
                </Routes>}
            </MenuLevelTwoContext.Provider>
        </div>
    );
}
